import React from 'react';
import { useNavigate } from 'react-router-dom';

const NavigationHub: React.FC = () => {
  const navigate = useNavigate();

  const handleRequestFormClick = () => {
    navigate('/request');
  };

  const handleAdminPanelClick = () => {
    navigate('/admin/submissions');
  };

  return (
    <div className="min-h-screen bg-surface text-ink-700 pt-16">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Header - Following existing page header pattern */}
        <div className="text-center mb-16">
          <h1 className="text-4xl sm:text-5xl font-bold mb-4 text-ink-900">
            <span className="gradient-text">Service Portal</span>
          </h1>
          <p className="text-lg text-ink-500 max-w-2xl mx-auto">
            Choose your path to access our services or manage submissions
          </p>
        </div>

          {/* Navigation Cards - Following existing glass-card pattern */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 max-w-4xl mx-auto">
          {/* Partner Request Card */}
          <div className="glass-card p-8 text-center group cursor-pointer" onClick={handleRequestFormClick}>
            <div className="flex flex-col items-center">
              {/* Icon - Following existing icon pattern from AdminDashboard */}
              <div className="w-20 h-20 flex items-center justify-center bg-gradient-to-r from-brand-start to-brand-end rounded-2xl mb-6 group-hover:scale-110 transition-transform duration-300">
                <svg className="w-10 h-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                </svg>
              </div>
              
              {/* Content */}
              <h2 className="text-2xl font-bold text-ink-900 mb-4">Submit New Request</h2>
              <p className="text-ink-500 mb-6 leading-relaxed">
                Submit a project request or resource request for software development services. 
                Get started with our comprehensive forms to tell us about your partnership needs.
              </p>
              
              {/* Button - Using existing btn-primary class */}
              <button className="btn-primary w-full max-w-xs">
                Go to Request Form
              </button>
            </div>
          </div>

          {/* Admin Panel Card */}
          <div className="glass-card p-8 text-center group cursor-pointer" onClick={handleAdminPanelClick}>
            <div className="flex flex-col items-center">
              {/* Icon - Following existing icon pattern from AdminDashboard */}
              <div className="w-20 h-20 flex items-center justify-center bg-gradient-to-r from-purple-500 to-indigo-600 rounded-2xl mb-6 group-hover:scale-110 transition-transform duration-300">
                <svg className="w-10 h-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                </svg>
              </div>
              
              {/* Content */}
              <h2 className="text-2xl font-bold text-ink-900 mb-4">Admin Panel</h2>
              <p className="text-ink-500 mb-6 leading-relaxed">
                View and manage all partner requests and submissions. 
                Access comprehensive tools for tracking, filtering, and processing requests.
              </p>
              
              {/* Button - Using existing btn-secondary class for distinction */}
              <button className="btn-secondary w-full max-w-xs">
                Go to Admin Panel
              </button>
            </div>
          </div>
        </div>

        {/* Additional Info Section - Following existing pattern */}
        <div className="mt-16 text-center">
          <div className="glass-card p-6 max-w-2xl mx-auto">
            <h3 className="text-xl font-semibold text-ink-900 mb-3">Need Help?</h3>
            <p className="text-ink-500">
              If you're unsure which option to choose, 
              <span className="text-brand-start font-medium"> Submit New Request</span> is for partners looking to request our services, 
              while <span className="text-brand-start font-medium">Admin Panel</span> is for managing existing submissions.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NavigationHub;
